export function monitoringLabel(item) {
  if (item.checking_enabled === false || item.checking_enabled === 0) return 'Monitoring paused';
  if (item.check_reason === 'unsupported') return 'Unsupported name format';
  if (item.monitoring_capability === 'existence_only' && item.check_health === 'unknown' && item.check_reason === 'profile_not_visible') return 'Profile not confirmed';
  if (item.revalidation_required) return 'Awaiting recheck';
  if (['unknown', 'error'].includes(item.check_health)) return 'Checking delayed';
  if (!item.last_checked || item.status === 'pending') return 'Not checked yet';
  if (item.monitoring_capability === 'existence_only') return item.status === 'unavailable' ? 'Account found' : 'Profile not confirmed';
  return item.status === 'available' ? 'May be available' : 'Taken at last check';
}
export function isCurrentOpportunity(item) {
  return monitoringLabel(item) === 'May be available';
}
export function monitoringTone(item) {
  const label = monitoringLabel(item);
  if (label === 'May be available') return 'opportunity';
  if (['Monitoring paused', 'Unsupported name format', 'Awaiting recheck', 'Checking delayed'].includes(label)) return 'attention';
  return 'neutral';
}
export function monitoringExplanation(item) {
  const label = monitoringLabel(item);
  if (label === 'Monitoring paused') return item.paused_reason || 'This platform is not currently being checked.';
  if (label === 'Unsupported name format') return 'This checker cannot read this name. Stop watching it and add a name in the supported format.';
  if (label === 'Awaiting recheck') return 'A fresh check is needed before this result can be relied on.';
  if (label === 'Checking delayed') {
    return ({ blocked: 'The platform prevented the latest check. NameCamper will retry automatically.', rate_limited: 'The platform is limiting requests. Checks will retry after a delay.' })[item.check_reason] || 'The latest attempt was inconclusive. NameCamper will retry automatically.';
  }
  if (label === 'Not checked yet') return 'Saved and waiting for its first eligible scheduled check.';
  if (label === 'Account found') return 'An account with this handle was found at the last successful check.';
  if (label === 'Profile not confirmed') return 'The latest check could not confirm this profile.';
  if (label === 'May be available') return 'A signal from the last successful check, not a live guarantee. Verify directly before claiming or registering.';
  return 'The name was in use at the last successful check.';
}
